export const MAP_IDS = ["air", "ground"] as const;
export type MapId = (typeof MAP_IDS)[number];

export function isMapId(v: unknown): v is MapId {
  return typeof v === "string" && (MAP_IDS as readonly string[]).includes(v);
}
